import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { LoadingIndicator, User } from 'components/common';
import { Box, BoxEmpty } from 'components/common/box';

import type { GetUserSupervisorsRes } from 'shared-types/responses';

interface Props {
  isUserPage: boolean;
  targetUserId: number;
}

const ProfileSupervisors = ({ isUserPage, targetUserId }: Props) => {
  const { messages } = useReduxState();

  const { data, loading } = useApiData<GetUserSupervisorsRes>({
    url: `/admin/users/${targetUserId}/supervisors`
  });

  const supervisors = data?.supervisors;

  return (
    <Box title={messages.adminSupervisors}>
      {loading ? (
        <LoadingIndicator />
      ) : supervisors?.length ? (
        <div className="supervisors">
          {supervisors.map((supervisor) => (
            <div className="supervisor" key={supervisor.id}>
              <User
                enableProfileLink={isUserPage}
                size="small"
                user={supervisor}
              />
            </div>
          ))}
        </div>
      ) : (
        <BoxEmpty align="center" text={messages.adminSupervisorsEmpty} />
      )}

      <style jsx>{`
        .supervisors {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -10px 0;
        }
        .supervisor {
          margin-right: 50px;
          padding: 10px;
        }
      `}</style>
    </Box>
  );
};

export default ProfileSupervisors;
